import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RmsModule } from '@rms';
import { CustomerCrmService, RmsMessageService, RmsPulldownService } from '@services';
import { NoteFormComponent } from './note-form/note-form.component';
import { NoteHistoryComponent } from './note-history/note-history.component';

@Component({
  selector: 'app-customer-notes',
  imports: [RmsModule],
  templateUrl: './customer-notes.component.html',
  styleUrl: './customer-notes.component.scss'
})
export class CustomerNotesComponent implements OnChanges {
  @Input() companyId!: number;
  @Input() canEdit = false;
  Notes: any[] = [];

  constructor(
    private crm: CustomerCrmService,
    private message: RmsMessageService,
    private pulldown: RmsPulldownService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['companyId']) {
      this.load();
    }
  }

  load() {
    if (!this.companyId) return;
    this.crm.getNotes(this.companyId, false).subscribe({
      next: (notes) => {
        this.Notes = [...(notes || [])].sort((a: any, b: any) => new Date(b.EntryDate).getTime() - new Date(a.EntryDate).getTime()).map((n: any) => ({
          ...n,
          DateDisplay: n.EntryDate ? new Date(n.EntryDate).toLocaleDateString() : '—',
          AuthorDisplay: n.EnteredByName || '—',
          RelatedDisplay: n.RelatedOrderID ? `Order #${n.RelatedOrderID}`
            : n.RelatedSampleRequestID ? `Sample #${n.RelatedSampleRequestID}`
            : 'Customer'
        }));
      },
      error: (err) => this.message.error('Failed to load notes: ' + this.errorText(err))
    });
  }

  openNoteForm(note?: any) {
    if (!this.canEdit) return;
    const ref = this.pulldown.open(NoteFormComponent, {
      title: note ? 'Edit Note' : 'Add Note',
      width: 'clamp(480px, 50vw, 720px)',
      data: note ? { NoteID: note.NoteID, NoteText: note.NoteText, FollowUpDate: note.FollowUpDate, RelatedOrderID: note.RelatedOrderID, RelatedSampleRequestID: note.RelatedSampleRequestID } : {}
    });

    ref.afterClosed().subscribe((result: any) => {
      if (!result || result.cancelled) return;
      result.CompanyID = this.companyId;
      result.EnteredBy = localStorage.getItem('GUID');
      this.crm.saveNote(result).subscribe({
        next: () => {
          this.message.success(`Note ${note ? 'updated' : 'added'} successfully`);
          this.load();
        },
        error: (err) => this.message.error('Failed to save note: ' + this.errorText(err))
      });
    });
  }

  viewHistory(note: any) {
    this.crm.getNotes(this.companyId, true).subscribe({
      next: (allVersions) => {
        const versions = (allVersions || [])
          .filter((n: any) => n.NoteID === note.NoteID)
          .map((n: any) => ({
            ...n,
            DateDisplay: n.EntryDate ? new Date(n.EntryDate).toLocaleDateString() : '—',
            AuthorDisplay: n.EnteredByName || '—'
          }))
          .sort((a: any, b: any) => new Date(b.EntryDate).getTime() - new Date(a.EntryDate).getTime());

        this.pulldown.open(NoteHistoryComponent, {
          title: 'Note History',
          // Fixed pixel width (not vw-relative) so it renders identically regardless of
          // browser window size or how much content is inside.
          width: '900px',
          maxWidth: '900px',
          data: { versions }
        });
      },
      error: (err) => this.message.error('Failed to load note history: ' + this.errorText(err))
    });
  }

  private errorText(err: any): string {
    return err?.error?.error?.message || err?.message || 'Unknown error';
  }
}
